import React, {useContext} from 'react';
import { Translate } from '../common/Translate';
import TciSimpleDate from '../datePicker/TciSimpleDate';
import ExpenseContext from '../contexts/expense-context';

const ExpenseArrangement = props => {

    const { arrangement, setArrangement } = useContext(ExpenseContext);

    return (
        <div className="expense-general__row narrow">
            <div className="expense-general__label">
                <svg className="expense-general__label--icon-small icon icon-user selected-filter__combo-item-icon">
                    <use xlinkHref="../img/sprite.svg#icon-calendar"></use>
                </svg>
                <span className="expense-general__label--label">
                    <Translate>ExpenseArrangement</Translate>
                </span>
            </div>
            <div className="expense-general__input">
                <TciSimpleDate startDate={arrangement} setStartDate={setArrangement} />
            </div>
            <div className="expense-general__buttons">

            </div>
        </div>
    )
}

export default ExpenseArrangement;